/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Triggers_SubtitleInputs */



/**
* | output |
* | --- |
* | "Start this agent's runs automatically, on a schedule or when something happens." |
*
* @param {Agent_Triggers_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_triggers_subtitle = /** @type {((inputs?: Agent_Triggers_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Triggers_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Läufe dieses Agenten automatisch starten, nach Zeitplan oder wenn etwas passiert.")
	return /** @type {LocalizedString} */ ("Start this agent's runs automatically, on a schedule or when something happens.")
});